import PropTypes from 'prop-types';
import React, { useContext, useEffect, useState } from 'react';
import { Popconfirm, Popover } from 'antd';
import {
  mdiPlus,
  mdiTrashCanOutline,
} from '@mdi/js';
import Icon from '@mdi/react';

import { antNotification, capitalizeAndTranslateMsg } from '../../../mainUtils';
import { ApiContext } from '../../../api/ApiContextProvider';
import { ActorsConstants } from '../../constants/actionTypes';
import useAuthActorsRequests from '../../hooks/useAuthActorsRequests';
import useURLParams from '../../../hooks/useURLParams';
import BaseIcon from '../../../_ui/BaseIcon/BaseIcon';

function ServiceListingGroupLink({
  actorUUID,
  listingGroupUUID,
  onSuccessActorUpdate,
}) {
  const { requestGetActorOnAuth } = useAuthActorsRequests();

  const { manageServiceListingGroup } = useContext(ApiContext);
  const { setSearchParams } = useURLParams();

  const [popConfirmVisible, changePopConfirmVisible] = useState(false);

  const popConfirmVisibleToggle = () => changePopConfirmVisible(!popConfirmVisible);

  const getService = () => (
    requestGetActorOnAuth({ uuid: actorUUID })
  );

  const getListingGroup = (uuid) => (
    requestGetActorOnAuth({
      uuid,
      constants: [
        ActorsConstants.CHECK_LISTING_GROUP_REQUEST,
        ActorsConstants.CHECK_LISTING_GROUP_SUCCESS,
        ActorsConstants.CHECK_LISTING_GROUP_FAILURE,
      ],
    })
  );

  // const getListingGroupAndSaveToStore = (uuid) => {
  //     getListingGroup(uuid).then((res) => {
  //         dispatch({
  //             type: ActorsConstants.CREATE_ACTOR_SUCCESS,
  //             payload: res
  //         })
  //
  //     })
  // }

  const checkLinkAndGoToActor = () => {
    getListingGroup(listingGroupUUID)
      .then(() => {
        setSearchParams({
          view: 'info',
          uuid: listingGroupUUID,
          type: 'group',
        });
      })
      .catch(({ status }) => {
        if (status === 400) {
          // console.log('error', status)
          changePopConfirmVisible(true);
        }
      });
  };

  const createListingGroupAndConnectToService = () => (
    manageServiceListingGroup({
      serviceUUID: actorUUID,
    }).then(() => {
      antNotification.success('Success');
    })
  );

  const createListingGroupAndGetService = async () => {
    await createListingGroupAndConnectToService();
    await getService().then(() => {
      // TODO: Rewrite this update callback
      if (onSuccessActorUpdate) {
        onSuccessActorUpdate();
      }
    });
  };

  const removeListingGroup = () => (
    manageServiceListingGroup({
      serviceUUID: actorUUID,
      requestMethod: 'delete',
    }).then(() => {
      antNotification.success('Success');
    })
  );

  const removeListingGroupAndGetService = async () => {
    await removeListingGroup();
    await getService();
  };

  const removeListingGroupLinkAndCreateListingGroup = async () => {
    await removeListingGroup();
    await createListingGroupAndConnectToService();
    await getService().then((res) => {
      // const uuid = res?.actor?.uinfo?.listing_group;
      //
      // if(uuid) {
      //     getListingGroupAndSaveToStore(uuid)
      // }

      // TODO: Rewrite this update callback
      if (onSuccessActorUpdate) {
        onSuccessActorUpdate();
      }
    });
  };

  useEffect(() => {
    changePopConfirmVisible(false);
  }, [actorUUID]);

  return (
    <>
      <Popconfirm
        title={listingGroupUUID
          ? capitalizeAndTranslateMsg('auth.messages.remove_link_and_create_new', 'remove_link_and_create_new')
          : capitalizeAndTranslateMsg('auth.messages.listing_group_will_be_created', 'listing_group_will_be_created')}
        onConfirm={listingGroupUUID ? removeListingGroupLinkAndCreateListingGroup : createListingGroupAndGetService}
        onCancel={popConfirmVisibleToggle}
        okText={capitalizeAndTranslateMsg('auth.buttons.yes', 'yes')}
        cancelText={capitalizeAndTranslateMsg('auth.buttons.no', 'no')}
        open={popConfirmVisible}
      />

      <span
        className="cursor-pointer"
        style={{
          color: '#038fde',
        }}
        onClick={listingGroupUUID ? checkLinkAndGoToActor : popConfirmVisibleToggle}
      >
        {!listingGroupUUID
                    && (
                    <BaseIcon
                      className="mr-2 "
                      path={mdiPlus}
                      size={1}
                    />
                    )}
        <span>
          {listingGroupUUID
            ? capitalizeAndTranslateMsg('auth.buttons.go_to_listing_group', 'Go to listing group')
            : capitalizeAndTranslateMsg('auth.buttons.create_listing_group', 'Create listing group')}
        </span>
      </span>

      {listingGroupUUID
                && (
                <Popover
                  placement="right"
                  content={capitalizeAndTranslateMsg('auth.tooltips.remove_listing_group', 'remove_listing_group')}
                >
                  <Popconfirm
                    placement="topLeft"
                    title={capitalizeAndTranslateMsg('auth.messages.are_you_sure', 'are_you_sure')}
                    onConfirm={removeListingGroupAndGetService}
                    okText={capitalizeAndTranslateMsg('auth.buttons.yes', 'yes')}
                    cancelText={capitalizeAndTranslateMsg('auth.buttons.no', 'no')}
                  >
                    <BaseIcon
                      className="ml-2 cursor-pointer"
                      path={mdiTrashCanOutline}
                      size={1}
                    />
                  </Popconfirm>
                </Popover>
                )}
    </>
  );
}

export default ServiceListingGroupLink;

ServiceListingGroupLink.propTypes = {
  actorUUID: PropTypes.string,
  listingGroupUUID: PropTypes.string,
  onSuccessActorUpdate: PropTypes.func,
};
